<template>
  <div>
    <section ref="section3" class="mx-auto flex h-full flex-col">
      <v-register-head
        @previous="2"
        :step="3"
        :landing-route="registrationProcessData.routes.landing"
      ></v-register-head>
      <div
        class="flex h-full flex-col items-center justify-between px-4 py-8 md:px-12"
      >
        <figure class="flex w-full max-w-lg flex-col gap-11 lg:w-full">
          <figure class="flex gap-3">
            <div><v-icon icon="user-plus" size="8"></v-icon></div>
            <div class="flex flex-col justify-center">
              <div class="mb-3 text-heading-3-desktop">
                Ustvarite svoj račun
              </div>
            </div>
          </figure>
          <figure class="flex flex-col gap-6">
            <figure>
              <img
                class="lazy mx-auto h-[251px] w-[146px]"
                :src="'/assets/images/social-account.webp'"
              />
            </figure>
            <figure class="flex flex-col items-center gap-4 lg:gap-6">
              <a
                :href="registrationProcessData.routes.submitEmail"
                class="button button--form"
              >
                <label>Elektronska pošta</label>
                <v-icon icon="envelope"></v-icon>
              </a>
              <!--
              <div class="justficy-center flex w-full items-center">
                <div class="h-[1px] w-full bg-gray"></div>
                <div class="pl-6 pr-6 text-small-text-medium text-black-40">
                  ali
                </div>
                <div class="h-[1px] w-full bg-gray"></div>
              </div>
              <a
                @click="nextSection(3)"
                class="button button--form button--apple"
              >
                <v-icon icon="apple"></v-icon>
                <label class="ml-0 text-center">Nadaljujte z Applom</label>
              </a>
              <a
                @click="nextSection(3)"
                class="button button--form button--google"
              >
                <v-icon icon="google"></v-icon>
                <label class="ml-0 text-center">Nadaljujte z Googlom</label>
              </a>
              <a
                @click="nextSection(3)"
                class="button button--form button--facebook"
              >
                <v-icon icon="facebook"></v-icon>
                <label class="ml-0 text-center">Nadaljujte z Facebookom</label>
              </a>-->
            </figure>
          </figure>
        </figure>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    registrationProcessData: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
